<ion-footer class="hidden sm:flex relative">
  <div class="flex bg-[#102E6A] text-white text-[12px] w-full">
    <div class="w-[75%] py-5 ml-[10%]">
      <p>
        <!-- Teleflex, the Teleflex logo, and Arrow are trademarks or registered
        trademarks of Teleflex Incorporated or its affiliates, in the U.S.
        and/or other countries. All other trademarks are trademarks of their
        respective owners. -->
        Teleflex, the Teleflex logo, and Arrow, Endurance, VPS G4, and VPS Rhythm DLX are
        trademarks or registered trademarks of Teleflex Incorporated or its affiliates,
        in the U.S. and/or other countries. All other trademarks are trademarks of their
        respective owners.
      </p>
      <br />
      <p>
        &copy; {{ year }} Teleflex Incorporated. All rights reserved.
      </p>
    </div>
    <div class="align-middle my-auto mx-auto w-[22%] pr-[7%]">
      <img src="/assets/trademark/teleflex.png" alt="teleflex" />
    </div>
  </div>
</ion-footer>
